<template>
  <div class="num-counter-container">
    <div class="num-counter">
      <div @click="decrease" class="in">-</div>
      <input
        type="number"
        ref="count"
        pattern="[0-9]{2}"
        :min="min"
        :max="max"
        v-model="count"
        @change="change"
      />
      <div @click="increase" class="dc">+</div>
    </div>
    <span style="fontsize">
      {{ message }}
    </span>
  </div>
</template>
<script>
export default {
  props: ["min", "max", "value"],
  data() {
    return {
      message: "",
      count: this.value
    };
  },
  watch: {
    // keep local state in sync when parent changes the prop
    value(newVal) {
      const n = Number(newVal);
      // do not emit here to avoid loops; just mirror the prop
      this.count = isNaN(n) ? this.min : n;
    }
  },
  updated() {},
  methods: {
    increase() {
      const current = Number(this.count) || 0;
      const max = Number(this.max);
      if (current < max) {
        this.count = current + 1;
        this.message = "";
        this.$emit("input", this.count);
      } else {
        this.message = "موجودی کمتر از درخواست شماست";
      }
    },
    decrease() {
      const current = Number(this.count) || 0;
      const min = Number(this.min);
      if (current > min) {
        this.count = current - 1;
        this.message = "";
        this.$emit("input", this.count);
      } else {
        this.message = "حداقل تعداد خرید";
      }
    },
    change() {
      const min = Number(this.min);
      const max = Number(this.max);
      let val = Number(this.count);
      if (isNaN(val)) val = min;
      if (val > max) {
        this.count = max;
        this.message = "موجودی کمتر از درخواست شماست";
      } else if (val < min) {
        this.count = min;
        this.message = "حداقل تعداد خرید";
      } else {
        this.message = "";
        this.count = val;
      }
      this.$emit("input", this.count);
    }
  }
};
</script>
<style scoped>
.num-counter-container {
  position: relative;
  display: flex;
  flex-flow: column;
  margin: 0.75rem 0;
  justify-content: center;
  align-items: center;
}
.num-counter-container span {
  font-size: 11px;
  bottom: -20px;
  position: absolute;
  width: 160px;
  text-align: center;
  color: darkred;
}
.num-counter-container label {
  margin: 0 !important;
}
.num-counter {
  width: max-content;
  min-width: 80px;
  list-style: none;
  height: 38px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: auto 0.5rem;
  border-radius: 5px;
}

.num-counter input {
  border: none;
  width: max-content;
  min-width: 50px;
  text-align: center;
}

.num-counter .dc,
.num-counter .in {
  width: 20px;
  cursor: pointer;
  text-align: center;
}
</style>
